import React from 'react';

import { VIEWS } from '../constants';
import {
  CrmPages,
  JiraPage,
  LeavePage,
  ProfilePage,
  ProjectsPage,
  TeamPage,
  TimesheetsPage,
} from '../pages/lazy';
import TimelinePage from '../pages/Timeline';
import { MANAGER_ONLY_VIEWS } from '../routes';
import { useApp } from '../store/AppContext';
import JiraSyncAlert from './JiraSyncAlert';
import PreviewBanner from './mainContent/PreviewBanner';

/* Écran affiché pour chaque vue. Les écrans CRM partagent un même aiguillage (CrmPages). */
const PAGES = {
  [VIEWS.TIMELINE]: TimelinePage,
  [VIEWS.PROJECTS]: ProjectsPage,
  [VIEWS.TEAM]: TeamPage,
  [VIEWS.TIMESHEETS]: TimesheetsPage,
  [VIEWS.JIRA]: JiraPage,
  [VIEWS.CRM_HOME]: CrmPages,
  [VIEWS.CRM_DEALS]: CrmPages,
  [VIEWS.CRM_CONTACTS]: CrmPages,
  [VIEWS.CRM_FINANCE]: CrmPages,
  [VIEWS.CRM_TENDERS]: CrmPages,
  [VIEWS.LEAVE]: LeavePage,
  [VIEWS.PROFILE]: ProfilePage,
};

export default function MainContent() {
  const { isManager, previewMode, appState } = useApp();
  const { view } = appState;
  const Page = PAGES[view];
  const allowed = isManager || !MANAGER_ONLY_VIEWS.includes(view);
  return (
    <div className="content">
      {previewMode && <PreviewBanner />}
      <JiraSyncAlert />
      {Page && allowed && (
        // Une frontière par écran (les écrans CRM en partagent une) : changer d'écran remonte la page.
        <React.Suspense key={Page === CrmPages ? 'crm' : view} fallback={null}>
          <Page view={view} />
        </React.Suspense>
      )}
    </div>
  );
}
